import Select from 'react-select'
import AsyncSelect from 'react-select/async'

const SelectInput = ({
  label,
  value,
  options,
  onChange,
  error,
  filterOption,
  getOptionLabel,
  getOptionValue,
  loadingMessage,
  noOptionsMessage,
  defaultInputValue,
  defaultValue,
  load,
  formatOptionLabel,
  components,
  placeholder,
  isClearable,
  disabled,
  isMulti,
  styles,
}) => {
  return (
    <div className={`input-wrapper${error ? ' input-wrapper--error' : ''}${isMulti ? ' input-wrapper--multi' : ''}`}>
      <label>
        { label && <span>{ label }</span> }
        {
          load ?
          <AsyncSelect
            loadOptions={load}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            loadingMessage={loadingMessage}
            noOptionsMessage={noOptionsMessage ? noOptionsMessage : () => 'Valikud puuduvad'}
            value={value}
            onChange={onChange}
            defaultInputValue={defaultInputValue}
            defaultValue={defaultValue}
            formatOptionLabel={formatOptionLabel}
            components={components}
            placeholder={placeholder ? placeholder : 'Vali'}
            isDisabled={disabled}
          />
          :
          <Select
            options={options}
            onChange={onChange}
            value={value}
            isClearable={isClearable}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            loadingMessage={loadingMessage}
            noOptionsMessage={noOptionsMessage ? noOptionsMessage : () => 'Valikud puuduvad'}
            filterOption={filterOption}
            formatOptionLabel={formatOptionLabel}
            components={components}
            placeholder={placeholder ? placeholder : 'Vali'}
            isDisabled={disabled}
            isMulti={isMulti}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), ...styles }}
          />
        }
      </label>
      { error &&
        <div className="input-error">{ error }</div>
      }
    </div>
  )
}

export default SelectInput